var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "img-wrap" },
    _vm._l(_vm.photoList, function (item, index) {
      return _c(
        "div",
        { key: index, staticClass: "img-content" },
        [
          _c("el-image", {
            staticStyle: { width: "100px", height: "100px", margin: "20px" },
            attrs: { src: item.fileUrl, "preview-src-list": _vm.imgList },
          }),
          _c("span", { staticClass: "upload-time" }, [
            _vm._v(_vm._s(item.lastModified || "--")),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }